import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime'
import { forwardRef } from 'react'
const SvgBrandIconCollectRedPoints = (props, ref) =>
  _jsxs('svg', {
    viewBox: '0 0 48 48',
    xmlns: 'http://www.w3.org/2000/svg',
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    ref: ref,
    ...props,
    children: [
      _jsx('circle', { cx: 24, cy: 24, r: 24, fill: '#fcf7f7' }),
      _jsx('path', {
        d: 'M28.013 13.444a6.54 6.54 0 0 0-5.52 3.043c-.115-.005-.227-.018-.343-.018a9.084 9.084 0 1 0 0 18.168c4.971 0 9.003-3.994 9.077-8.947a6.55 6.55 0 0 0 3.334-5.698 6.555 6.555 0 0 0-6.548-6.548m0 12.095a5.554 5.554 0 0 1-5.547-5.547 5.554 5.554 0 0 1 5.547-5.548 5.554 5.554 0 0 1 5.548 5.548 5.554 5.554 0 0 1-5.548 5.547m3.162-7.318-2.523 4.078a.497.497 0 0 1-.72.14l-2.785-2.044a.5.5 0 0 1 .591-.807l2.349 1.724 2.238-3.618a.499.499 0 1 1 .85.527M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0m0 39.53c-8.577 0-15.53-6.953-15.53-15.53S15.424 8.47 24 8.47 39.53 15.424 39.53 24 32.576 39.53 24 39.53',
      }),
    ],
  })
const ForwardRef = forwardRef(SvgBrandIconCollectRedPoints)
export default ForwardRef
